import { render, staticRenderFns } from "./SalespersonDashboard.vue?vue&type=template&id=44b16b69"
import script from "./SalespersonDashboard.vue?vue&type=script&lang=js"
export * from "./SalespersonDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports